import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function postAgent18(params) {
  return authPost(`${baseUrl}/Agent18.ashx`, params);
}

export function postAgent19(params) {
  return authPost(`${baseUrl}/Agent19.ashx`, params);
}

export function postAgent20(params) {
  return authPost(`${baseUrl}/Agent20.ashx`, params);
}
